<template>
  <b-container
    fluid
    class="mb-5"
  >
    <b-breadcrumb
      v-if="$route.meta.breadcrumb"
      :items="$route.meta.breadcrumb || []"
    />
    <b-card>
      <b-row class="mb-2">
        <b-col cols="12">
          <b-form-group>
            <label>Search String</label>
            <b-input
              v-model="tableSettings.filter"
              type="text"
              placeholder="Enter search string"
              debounce="1000"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-button
            type="button"
            variant="success"
            @click="onShowAddForm"
          >
            Add Cluster
          </b-button>
        </b-col>
        <b-col cols="12">
          <b-table
            ref="table"
            hover
            responsive
            class="mt-2"
            :per-page="tableSettings.perPage"
            :current-page="tableSettings.currentPage"
            :items="myProvider"
            :fields="tableSettings.fields"
            :sort-by.sync="tableSettings.sortBy"
            :sort-desc.sync="tableSettings.sortDesc"
            :sort-direction="tableSettings.sortDirection"
            :filter="tableSettings.filter"
            :filter-included-fields="tableSettings.filterOn"
            show-empty
          >
            <template #cell(index)="data">
              {{ tableSettings.currentPage * tableSettings.perPage - tableSettings.perPage + (data.index + 1) }}
            </template>
            <template #cell(actions)="row">
              <div class="text-nowrap">
                <b-button
                  size="sm"
                  @click="onShowEditForm(row.item)"
                >
                  Edit
                </b-button>
              </div>
            </template>

            <template #cell(active)="data">
              {{ data.item.active === 1 ? "Yes" : "No" }}
            </template>
          </b-table>
          <b-row>
            <b-col
              cols="12"
              sm="6"
            >
              <div class="w-100 w-sm-25 mb-2 sm-mb-2">
                <b-select
                  v-model="tableSettings.perPage"
                  :options="tableSettings.pageOptions"
                  size="sm"
                />
              </div>
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="tableSettings.currentPage"
                :total-rows="tableSettings.totalRows"
                :per-page="tableSettings.perPage"
                first-number
                last-number
                pills
                prev-text="Prev"
                next-text="Next"
                aria-controls="table"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-cluster-form"
      scrollable
      no-close-on-backdrop
      :title="modalTitle"
      class="mb-5"
      @ok="onConfirmSubmit"
      @show="onShowModalForm"
    >
      <ValidationObserver
        ref="form"
      >
        <form
          role="form"
          novalidate
        >
          <Input
            initial-name="Cluster Code"
            initial-id-input="cluster_code"
            initial-input-type="text"
            :initial-input-value="cluster.cluster_code"
            :initial-rules="{ required: true }"
            @changeValue="onChangeValue"
          />

          <Input
            initial-name="Cluster Name"
            initial-id-input="cluster_name"
            initial-input-type="text"
            :initial-input-value="cluster.cluster_name"
            :initial-rules="{ required: true }"
            @changeValue="onChangeValue"
          />

          <div
            v-if="editMode && cluster.id !== 0"
            class="form-group"
          >
            <b-form-checkbox
              id="is_active"
              v-model="cluster.active"
              name="is_active"
              value="1"
              unchecked-value="0"
            >
              Is Active?
            </b-form-checkbox>
          </div>
        </form>
      </ValidationObserver>

      <template #modal-footer="{ok, cancel}">
        <b-button
          variant="success"
          @click="ok()"
        >
          {{ editMode ? 'Update Record' : 'Save Record' }}
        </b-button>
        <b-button
          variant="danger"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import { core } from '@/config/pluginInit'
import { AxiosError, ClusterService } from '@/services'
import formatter from '@/mixins/formatter'
import Input from '@/components/FormInput/InputType'

export default {
  name: 'AdminClusters',

  middleware: ['auth', 'marketing-officer'],

  components: {
    Input
  },

  metaInfo () {
    return {
      title: 'Clusters'
    }
  },

  mixins: [formatter],

  data () {
    return {
      isBusy: true,
      editMode: false,
      cluster: {
        id: 0,
        cluster_code: '',
        cluster_name: '',
        active: 0
      },
      tableSettings: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: '',
        filterOn: [],
        fields: [
          'index',
          'actions',
          { key: 'created_at', formatter: this.dateTimeFormatter, sortable: true },
          { key: 'cluster_code', sortable: true },
          { key: 'cluster_name', sortable: true },
          { key: 'active', label: 'IS ACTIVE?' },
          { key: 'updated_at', formatter: this.dateTimeFormatter, sortable: true }
        ]
      }
    }
  },

  computed: {
    modalTitle () {
      return this.editMode ? 'Edit Cluster' : 'Add Cluster'
    }
  },

  mounted () {
    core.index()
  },

  methods: {
    async myProvider (ctx) {
      try {
        const { data } = await ClusterService.get(`page=${ctx.currentPage}&per_page=${ctx.perPage}&sort=${ctx.sortBy}&sort_desc=${ctx.sortDesc}&filter_text=${ctx.filter}`)
        this.tableSettings.totalRows = data.total_rows
        return data.items
      } catch {
        return []
      }
    },

    onShowModalForm () {
      if (!this.editMode) {
        this.cluster.id = 0
        this.cluster.cluster_code = ''
        this.cluster.cluster_name = ''
        this.cluster.active = 1
      }
    },

    onShowAddForm () {
      this.editMode = false
      this.$bvModal.show('modal-cluster-form')
    },

    onShowEditForm (row) {
      this.editMode = true
      const { id, cluster_code, cluster_name, active } = row
      this.cluster = { id, cluster_code, cluster_name, active }
      this.$bvModal.show('modal-cluster-form')
    },

    async onConfirmSubmit (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.form.validate().then(async success => {
        if (success) {
          if (!this.editMode) {
            this.$swal.fire({
              title: 'Are you sure want to add this cluster?',
              icon: 'question',
              showCancelButton: true,
              confirmButtonColor: '#06C270',
              confirmButtonText: 'Submit',
              cancelButtonColor: '#FF2929',
              showLoaderOnConfirm: true,
              preConfirm: () => {
                return this.onSubmitPostForm()
              },
              allowOutsideClick: () => !this.$swal.isLoading()
            })
          } else {
            this.$swal.fire({
              title: 'Are you sure want to update this cluster?',
              icon: 'question',
              showCancelButton: true,
              confirmButtonColor: '#06C270',
              confirmButtonText: 'Update',
              cancelButtonColor: '#FF2929',
              showLoaderOnConfirm: true,
              preConfirm: () => {
                return this.onSubmitPutForm()
              },
              allowOutsideClick: () => !this.$swal.isLoading()
            })
          }
        } else {
          this.$bvModal.msgBoxOk('Oppss! There were problem with your inputs.', {
            title: 'Validation Error',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger'
          })
        }
      })
    },

    async onSubmitPostForm () {
      this.isBusy = true
      await ClusterService.post(this.cluster).then(response => {
        this.$bvModal.hide('modal-cluster-form')
        this.isBusy = false
        this.$swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.data.message,
          confirmButtonColor: '#06C270',
          confirmButtonText: 'Dismiss'
        }).then(() => {
          this.$refs.table.refresh()
        })
      }).catch(error => {
        if (error instanceof AxiosError) {
          if (error.code === 422) {
            this.$refs.form.setErrors(error.message)
          }
        }
        this.isBusy = false
      })
    },

    async onSubmitPutForm () {
      this.isBusy = true
      await ClusterService.put(this.cluster).then(response => {
        this.$bvModal.hide('modal-cluster-form')
        this.isBusy = false
        this.$swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.data.message,
          confirmButtonColor: '#06C270',
          confirmButtonText: 'Dismiss'
        }).then(() => {
          this.$refs.table.refresh()
        })
      }).catch(error => {
        if (error instanceof AxiosError) {
          if (error.code === 422) {
            this.$refs.form.setErrors(error.message)
          }
        }
        this.isBusy = false
      })
    },

    onChangeValue (value, name) {
      this.cluster[name] = value
    }
  }
}
</script>
